(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["prelaunch-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('HiveraneWaitlistDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const form = dialog.querySelector('form');
  const shownKey = 'hiverane_waitlist_visit_shown_v2';
  const closedKey = 'hiverane_waitlist_closed_at_v1';
  const subscribedKey = 'hiverane_waitlist_subscribed_at_v1';
  const pendingKey = 'hiverane_waitlist_pending_v1';
  const day = 86400000;
  const read = (store, key) => { try { return window[store].getItem(key); } catch { return null; } };
  const write = (store, key, value) => { try { window[store].setItem(key, value); } catch {} };
  const recent = (key, duration) => {
    const saved = Number(read('localStorage', key));
    return saved > 0 && Date.now() - saved < duration;
  };
  let opener = null;
  let shown = false;
  let delayElapsed = false;
  let purchaseStarted = false;
  let completed = dialog.dataset.subscribed === 'true';
  const show = () => {
    if (dialog.open || document.querySelector('dialog[open]')) return;
    opener = document.activeElement;
    shown = true;
    write('sessionStorage', shownKey, '1');
    dialog.showModal();
    const feedback = dialog.querySelector('.prelaunch-success,.prelaunch-error');
    if (feedback) { feedback.setAttribute('tabindex', '-1'); feedback.focus(); }
  };
  const autoShow = () => {
    if (document.querySelector('hiverane-guided')) return;
    if (shown || read('sessionStorage', shownKey) === '1' || !delayElapsed || completed || purchaseStarted) return;
    if (recent(closedKey, 7 * day) || recent(subscribedKey, 90 * day)) return;
    if (document.visibilityState !== 'visible' || document.activeElement?.closest('form') || document.querySelector('dialog[open]')) return;
    const pageDepth = (window.scrollY + window.innerHeight) / Math.max(document.documentElement.scrollHeight, 1);
    if (window.scrollY < 120 || pageDepth < 0.35) return;
    const visibleSignup = Array.from(document.querySelectorAll('.prelaunch-form')).some(signup => {
      if (dialog.contains(signup)) return false;
      const box = signup.getBoundingClientRect();
      return box.width > 0 && box.top < innerHeight && box.bottom > 0;
    });
    if (visibleSignup) return;
    const cookieBanner = document.querySelector('#shopify-pc__banner');
    if (cookieBanner && cookieBanner.getClientRects().length) return;
    show();
  };
  document.querySelectorAll('[data-waitlist-open]').forEach(button => button.addEventListener('click', event => { event.preventDefault(); show(); }));
  dialog.querySelectorAll('[data-waitlist-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    write('localStorage', closedKey, String(Date.now()));
    if (opener instanceof HTMLElement && opener.isConnected) opener.focus({preventScroll: true});
  });
  form?.addEventListener('submit', () => {
    write('sessionStorage', pendingKey, String(Date.now()));
    if (dialog.open) dialog.close();
  }, {capture: true});
  document.querySelectorAll('.hpd-purchase-panel form').forEach(purchaseForm => {
    purchaseForm.addEventListener('change', () => { purchaseStarted = true; });
    purchaseForm.addEventListener('submit', () => { purchaseStarted = true; });
  });
  document.addEventListener('scroll', autoShow, {passive: true});
  document.addEventListener('focusout', () => setTimeout(autoShow, 0));
  document.addEventListener('visitorConsentCollected', autoShow);
  document.addEventListener('visibilitychange', autoShow);
  document.addEventListener('click', () => setTimeout(autoShow, 0));
  setTimeout(() => { delayElapsed = true; autoShow(); }, 20000);
  const pending = Number(read('sessionStorage', pendingKey));
  const feedback = dialog.querySelector('.prelaunch-success,.prelaunch-error');
  if (feedback && pending && Date.now() - pending < 30 * 60000) {
    write('sessionStorage', pendingKey, '0');
    if (feedback.matches('.prelaunch-success')) {
      completed = true;
      write('localStorage', subscribedKey, String(Date.now()));
    }
    show();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
